import { Box, Grid2 } from '@mui/material';
import React from 'react';
import CustomCard from '@ui-components/Card/CustomCard';
import CustomCardContent from '@ui-components/Card/CustomCardContent';
import CustomTypography from '@ui-components/Typography/CustomTypography';

//Css
import './metrics.css';
import CustomDivider from '@ui-components/Divider/CustomDivider';
import type { MetricsResponse } from '../../API/services/metricsService';

interface MetricsProps {
  metricsCountData: MetricsResponse | null;
}

const MetricsCount: React.FC<MetricsProps> = ({ metricsCountData }) => {
  return (
    <>
      <Box className="pb-24">
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
            <CustomCard id="facility-metrics-count1">
              <CustomCardContent
                id="facility-metrics-content1"
                className="pb-none"
              >
                <Box className="flex">
                  <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Box className="pr-42 pl-32">
                      <CustomTypography
                        id="total-requests"
                        variant="h1"
                        color="textPrimary"
                        className="pb-4"
                      >
                        {metricsCountData?.totalRequests}
                      </CustomTypography>
                      <CustomTypography
                        id="total-requests-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        Total Requests
                      </CustomTypography>
                    </Box>
                  </Grid2>
                  <CustomDivider
                    orientation="vertical"
                    textAlign="right"
                    flexItem
                  ></CustomDivider>
                  <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Box className="pl-42 pr-42">
                      <CustomTypography
                        id="total-requests"
                        variant="h1"
                        color="textPrimary"
                        className="pb-4"
                      >
                        {metricsCountData?.newRequests}
                      </CustomTypography>
                      <CustomTypography
                        id="total-requests-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        New Requests
                      </CustomTypography>
                    </Box>
                  </Grid2>
                  <CustomDivider
                    orientation="vertical"
                    textAlign="right"
                    flexItem
                  ></CustomDivider>
                  <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Box className="pl-42">
                      <CustomTypography
                        id="total-requests"
                        variant="h1"
                        color="textPrimary"
                        className="pb-4"
                      >
                        {metricsCountData?.accepted}
                      </CustomTypography>
                      <CustomTypography
                        id="total-requests-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        Accepted
                      </CustomTypography>
                    </Box>
                  </Grid2>
                  <CustomDivider
                    orientation="vertical"
                    textAlign="right"
                  ></CustomDivider>
                </Box>
              </CustomCardContent>
            </CustomCard>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 7 }}>
            <CustomCard id="facility-metrics-count2">
              <CustomCardContent
                id="facility-metrics-content2"
                className="pb-none"
              >
                <Box className="flex">
                  <Grid2 size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5 }}>
                    <Box className="pr-32 pl-24">
                      <CustomTypography
                        id="total-requests"
                        variant="h1"
                        color="textPrimary"
                        className="pb-4"
                      >
                        {metricsCountData?.inProgress}
                      </CustomTypography>
                      <CustomTypography
                        id="total-requests-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        In Progress
                      </CustomTypography>
                    </Box>
                  </Grid2>
                  <CustomDivider
                    orientation="vertical"
                    textAlign="right"
                    flexItem
                  ></CustomDivider>
                  <Grid2 size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5 }}>
                    <Box className="pl-32 pr-32">
                      <CustomTypography
                        id="total-requests"
                        variant="h1"
                        color="textPrimary"
                        className="pb-4"
                      >
                        {metricsCountData?.callStarted}
                      </CustomTypography>
                      <CustomTypography
                        id="total-requests-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        Call Started
                      </CustomTypography>
                    </Box>
                  </Grid2>
                  <CustomDivider
                    orientation="vertical"
                    textAlign="right"
                    flexItem
                  ></CustomDivider>
                  <Grid2 size={{ xs: 12, sm: 12, md: 2.8, lg: 2.8 }}>
                    <Box className="pl-32 pr-32">
                      <CustomTypography
                        id="total-requests"
                        variant="h1"
                        color="textPrimary"
                        className="pb-4"
                      >
                        {metricsCountData?.callCompleted}
                      </CustomTypography>
                      <CustomTypography
                        id="total-requests-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        Call Completed
                      </CustomTypography>
                    </Box>
                  </Grid2>
                  <CustomDivider
                    orientation="vertical"
                    textAlign="right"
                    flexItem
                  ></CustomDivider>
                  <Grid2 size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5 }}>
                    <Box className="pl-32 pr-32">
                      <CustomTypography
                        id="total-requests"
                        variant="h1"
                        color="textPrimary"
                        className="pb-4"
                      >
                        {metricsCountData?.completed}
                      </CustomTypography>
                      <CustomTypography
                        id="total-requests-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        Completed
                      </CustomTypography>
                    </Box>
                  </Grid2>
                  <CustomDivider
                    orientation="vertical"
                    textAlign="right"
                    flexItem
                  ></CustomDivider>
                  <Grid2 size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5 }}>
                    <Box className="pl-32 pr-24">
                      <CustomTypography
                        id="total-requests"
                        variant="h1"
                        color="textPrimary"
                        className="pb-4"
                      >
                        {metricsCountData?.canceled}
                      </CustomTypography>
                      <CustomTypography
                        id="total-requests-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        Canceled
                      </CustomTypography>
                    </Box>
                  </Grid2>
                </Box>
              </CustomCardContent>
            </CustomCard>
          </Grid2>
        </Grid2>
      </Box>
      <Box className="flex pt-8">
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
            <Box className="flex">
              <CustomTypography
                id="title-popup"
                variant="body2"
                color="textSecondary"
                className="pr-12"
              >
                Status:
              </CustomTypography>
              <Box className="flex align-items-center">
                <Box className="new-color rounded-fill"></Box>
                <CustomTypography
                  id="title-popup"
                  variant="body2"
                  color="textPrimary"
                  className="pr-16 pl-4"
                >
                  New
                </CustomTypography>
                <Box className="inprogress-color rounded-fill"></Box>
                <CustomTypography
                  id="title-popup"
                  variant="body2"
                  color="textPrimary"
                  className="pr-16 pl-4"
                >
                  In Progress
                </CustomTypography>

                <Box className="callstarted-color rounded-fill"></Box>
                <CustomTypography
                  id="title-popup"
                  variant="body2"
                  color="textPrimary"
                  className="pr-16 pl-4"
                >
                  Call Started
                </CustomTypography>

                <Box className="callcompleted-color rounded-fill"></Box>
                <CustomTypography
                  id="title-popup"
                  variant="body2"
                  color="textPrimary"
                  className="pr-16 pl-4"
                >
                  Call Completed
                </CustomTypography>

                <Box className="completed-color rounded-fill"></Box>
                <CustomTypography
                  id="title-popup"
                  variant="body2"
                  color="textPrimary"
                  className="pr-16 pl-4"
                >
                  Completed
                </CustomTypography>

                <Box className="cancelled-color rounded-fill"></Box>
                <CustomTypography
                  id="title-popup"
                  variant="body2"
                  color="textPrimary"
                  className="pr-16 pl-4"
                >
                  Cancelled
                </CustomTypography>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default MetricsCount;
